import React from 'react';
import moment from 'moment';
import { CSSTransitionGroup } from 'react-transition-group';
import { withStyles } from '@material-ui/styles';
import styles, { durationEnd } from './styles';

const Bottom = ({ classes }) => (
  <CSSTransitionGroup
    transitionName={classes}
    transitionAppearTimeout={durationEnd}
    transitionAppear
  >
    <div className={classes.bottom}>
      <div>
        {window.conf && window.conf.version}
      </div>
      <div>
        {moment().format('YYYY')}
      </div>
      <div />
    </div>
  </CSSTransitionGroup>
);

export default withStyles(styles)(Bottom);
